import React from "react";
import { Stack, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import MintButton from "../MintButton";
import ConnectWallet from "../ConnectWallet";

// ---------------------------------------------------------------------
const ContainerStyle = styled("div")(({ theme }) => ({
  padding: "15px",
  borderBottom: "1px solid #ffffff80",
}));

const FirstDigitalStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "64px",
  fontFamily: "Helvetica",
}));

const WhoTitleStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "70px",
  fontFamily: "Helvetica",
}));

const WhoContentStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "20px",
  fontFamily: "Helvetica",
  lineHeight: 1.2,
}));

const TextFlowStyle = styled("div")(({ theme }) => ({
  overflow: "hidden",
  backgroundColor: "#fff",
  width: "100%",

  "@keyframes scrolling-left1": {
    "0%": {
      transform: "translateX(100%)",
    },
    "100%": {
      transform: "translateX(-100%)",
    },
  },

  "@keyframes scrolling-left2": {
    "0%": {
      transform: "translateX(0%)",
    },
    "100%": {
      transform: "translateX(-200%)",
    },
  },
}));

const TextFlowContentStyle = styled("p")(({ theme }) => ({
  fontFamily: "Helvetica",
  color: "#000",
  width: "100%",
  whiteSpace: "nowrap",
  padding: "8px 0",
}));

const TextAStyle = styled("span")(({ theme }) => ({
  fontSize: "20px",
  display: "inline-block",
  animation: "scrolling-left1 40s linear infinite",
}));

const TextBStyle = styled("span")(({ theme }) => ({
  fontSize: "20px",
  display: "inline-block",
  animation: "scrolling-left2 40s linear infinite",
  animationDelay: "20s",
}));

export default function AboutMobileContent({
  address,
  userSigner,
  localProvider,
  mainnetProvider,
  price,
  web3Modal,
  loadWeb3Modal,
  logoutOfWeb3Modal,
  blockExplorer,
  contract,
  remainTokenCount,
  remainMintCount,
  saleStatus,
}) {
  return (
    <Stack sx={{ mt: "90px" }}>
      <ContainerStyle>
        <FirstDigitalStyle>
          THE FIRST DIGITAL CREATIVE NEIGHBOR HOOD.
        </FirstDigitalStyle>
      </ContainerStyle>
      <Stack sx={{ py: 3, borderBottom: "1px solid #ffffff80" }}>
        <ConnectWallet
          web3Modal={web3Modal}
          loadWeb3Modal={loadWeb3Modal}
          logoutOfWeb3Modal={logoutOfWeb3Modal}
        />
      </Stack>
      <Stack>
        <Box
          component="img"
          src="/assets/IB-4.jpg"
          sx={{ height: "100%", objectFit: "cover" }}
        />
      </Stack>
      <ContainerStyle>
        <WhoTitleStyle>WHO</WhoTitleStyle>
      </ContainerStyle>
      <ContainerStyle>
        <WhoContentStyle>
          R/HOOD is the world's first on-chain creative neighbourhood, creating
          an off-chain community. R/HOOD is a creative curator and facilitator,
          supported by an NFT membership housed on the web3 open source
          infrastructure.
        </WhoContentStyle>
      </ContainerStyle>

      <TextFlowStyle>
        <TextFlowContentStyle>
          <TextAStyle>
            &nbsp;WELCOME TO OUR NEIGHBORHOOD WELCOME TO OUR NEIGHBORHOOD
          </TextAStyle>
          <TextBStyle>
            &nbsp;WELCOME TO OUR NEIGHBORHOOD WELCOME TO OUR NEIGHBORHOOD&nbsp;
          </TextBStyle>
        </TextFlowContentStyle>
      </TextFlowStyle>

      <Stack>
        <Box
          component="video"
          src="https://vimeo.com/719537880/c2686c8e57"
          sx={{
            width: "100%",
            height: "auto",
          }}
          controls
          muted
          loop
        />
      </Stack>
      <ContainerStyle>
        <WhoTitleStyle>UTILITY</WhoTitleStyle>
      </ContainerStyle>
      <ContainerStyle>
        <WhoContentStyle sx={{ fontSize: "22px" }}>
          IRL EVENTS. EXCLUSIVE CONTENT. LIMITED EDITION DROPS. SPECIAL EDITION
          MERCH. COLLABS. LIKE-MINDED PEOPLE. GIGS. DISCOUNTS. ART. MUSIC.
          PLACES. EXPERIENCES. MEMORIES. SUPPORT. ALLOWLIST. KNOWLEDGE. ALPHA.
        </WhoContentStyle>
      </ContainerStyle>

      <ContainerStyle>
        <WhoTitleStyle sx={{ fontSize: "30px" }}>
          MINT YOUR R/HOOD NFT MEMBERSHIP
        </WhoTitleStyle>
      </ContainerStyle>

      <Stack>
        <Box
          component="img"
          src="/assets/RHOOD2.png"
          sx={{ height: "100%", objectFit: "cover" }}
        />
      </Stack>

      <Stack sx={{ p: 4 }}>
        <WhoTitleStyle sx={{ fontSize: "30px", pb: 3 }}>
          Mint your R/HOOD membership, and get a unique NFT featurying you, with
          various rarity traits.
        </WhoTitleStyle>

        <Stack alignItems="center">
          <MintButton
            address={address}
            localProvider={localProvider}
            userSigner={userSigner}
            mainnetProvider={mainnetProvider}
            price={price}
            web3Modal={web3Modal}
            loadWeb3Modal={loadWeb3Modal}
            logoutOfWeb3Modal={logoutOfWeb3Modal}
            blockExplorer={blockExplorer}
            contract={contract}
            remainTokenCount={remainTokenCount}
            remainMintCount={remainMintCount}
            saleStatus={saleStatus}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
